export default {"src":"/_next/static/media/drag_drop_image.c30a5971.svg","height":100,"width":111,"blurWidth":0,"blurHeight":0};